export interface FaqItem {
  q: string;
  a: string;
}

function FaqEntry({
  f,
  itemClass,
  triggerClass,
  bodyClass,
}: {
  f: FaqItem;
  itemClass: string;
  triggerClass: string;
  bodyClass: string;
}) {
  return (
    <details className={`group ${itemClass}`}>
      <summary
        className={`flex cursor-pointer list-none items-center justify-between gap-4 [&::-webkit-details-marker]:hidden ${triggerClass}`}
      >
        <span className="flex-1 text-left">{f.q}</span>
        <svg
          aria-hidden
          className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </summary>
      <div className={bodyClass}>{f.a}</div>
    </details>
  );
}

/** Card-style FAQ (homepage) - each item is a full rounded card */
export function FaqCards({ faqs }: { faqs: FaqItem[] }) {
  return (
    <>
      {faqs.map((f, i) => (
        <FaqEntry
          key={i}
          f={f}
          itemClass="mb-3 overflow-hidden rounded-xl border border-border bg-background px-5 shadow-sm transition hover:shadow-md"
          triggerClass="py-5 font-serif text-base font-semibold md:text-lg"
          bodyClass="pb-5 text-base leading-relaxed text-muted-foreground"
        />
      ))}
    </>
  );
}

/** Simple border-separated FAQ list (pillar/service-area pages) */
export function FaqList({
  faqs,
  className = "mt-8",
  serif = false,
}: {
  faqs: FaqItem[];
  className?: string;
  serif?: boolean;
}) {
  return (
    <div className={className}>
      {faqs.map((f, i) => (
        <FaqEntry
          key={i}
          f={f}
          itemClass="border-b border-border"
          triggerClass={`py-4 text-base font-semibold${serif ? " font-serif" : ""}`}
          bodyClass="pb-4 text-sm leading-relaxed text-muted-foreground"
        />
      ))}
    </div>
  );
}
